import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import LoadingPage from '../../components/LoadingPage';
import { getRestaurant } from '../../reducers';
import FormBusinessDaysResto from '../FormBusinessDaysResto';

class ConfigurationBusinessDays extends Component {
    render() {
        const { restaurant } = this.props;
        return (
            <div>
            {
                restaurant ?
                    <FormBusinessDaysResto />
                    :
                    <LoadingPage />
            }
            </div>
        );
    }
}

ConfigurationBusinessDays.propTypes = {
    restaurant: PropTypes.object.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
});

const mapStateToProps = state => ({
    restaurant:  getRestaurant(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(ConfigurationBusinessDays));